import { render } from "./warehouse-sales.vue?vue&type=template&id=c7ae9912"
import script from "./warehouse-sales.vue?vue&type=script&lang=js"
export * from "./warehouse-sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__